<div class="row">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.TaxInformation.Title' | translate}}</h2>
  </div>
</div>

<div class="row">

  <!--Tabela de IRS-->
  <!--Activo: Sim, se Benefício Requerido = SO ou SM e Tipologia de pessoa = Singular e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="irsTable"
             [class.disabled]=" personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!(  personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.TaxInformation.Fields.IRSTable' | translate}}
      </label>
      <select class="custom-select"
              [(ngModel)]="cardData.irsTableCode"
              name="irsTable"
              #irsTable="ngModel"
              [clearRelated]="{model : this.cardData , propsToReset : ['desvalorizationPercentage']} "
              [dropdownTitle]="{value : cardData.irsTable , dimensions :  fiscalCategories }"
              [disabled]=" personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()"
              [required]="!(  personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido())"
              (change)="onChangeIrsTable($event.target.value)"
              nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of fiscalCategories" [value]="domain.code">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="irsTable"></validation-message>
    </div>
  </div>

  <!--Percentagem de desvalorização-->
  <!--Activo: Sim, se "Tabela de IRS" = Deficiente e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label [class.disabled]="cardData.irsTableCode != 'DEF'|| isNotStateRLDiferido() " for="DevaluationPercentage">
        <span class="mandatory" *ngIf="!(cardData.irsTableCode != 'DEF'|| isNotStateRLDiferido())">*</span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.TaxInformation.Fields.DevaluationPercentage' | translate}}
      </label>
      <div class="position-relative">
        <input class="form-control input-right"
               type="text"
               percentage
               [(ngModel)]="cardData.desvalorizationPercentage"
               #desvalorizationPercentage="ngModel"
               name="desvalorizationPercentage"
               minValue="0"
               maxValue="100"
               maxlength="6"
               placeholder="{{'Placeholders.Generic.Percentage' | translate}}"
               [disabled]="cardData.irsTableCode != 'DEF'|| isNotStateRLDiferido()"
               [required]="!(cardData.irsTableCode != 'DEF'|| isNotStateRLDiferido())"
               messageFieldType="percentage">
        <span class="input-icon-span-right">%</span>
        <validation-message [control]="desvalorizationPercentage"></validation-message>
      </div>
    </div>
  </div>

  <!--Titularidade de rendimentos-->
  <!--Activo: Sim, se Benefício Requerido = SO ou SM e Tipologia de pessoa = Singular e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="revenueTitularityCode"
             [class.disabled]="  personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!(  personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.TaxInformation.Fields.IncomeOwnership' | translate}}
      </label>
      <select class="custom-select"
              [(ngModel)]="cardData.revenueTitularityCode"
              name="revenueTitularityCode"
              #revenueTitularityCode="ngModel"
              required
              [dropdownTitle]="{value : cardData.revenueTitularityCode, dimensions : incomeHoldings }"
              [disabled]="  personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()"
              [required]="!(  personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido())"
              nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of getOrderedIncomeHoldings()" [value]="domain.code">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="revenueTitularityCode"></validation-message>
    </div>
  </div>

</div>

<div class="row">
  <!--Taxa inteira por opção-->
  <!--Activo: Sim, se Benefício Requerido = SO ou SM e Tipologia de pessoa = Singular e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="FullRateOption"
             [class.disabled]="  personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="false">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.TaxInformation.Fields.FullRateOption' | translate}}
        <span class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberFiscalInfo.FullTaxOption' | translate}}"></span>
      </label>
      <div class="position-relative">
        <input class="form-control"
               type="text"
               percentage
               maxlength="5"
               placeholder="{{'Placeholders.CardSubscriberFiscalInfo.FullTaxOption' | translate}}"
               [(ngModel)]="cardData.entireRatePerOption"
               #entireRatePerOption="ngModel"
               name="entireRatePerOption"
               minValue="0"
               maxValue="40"
               messageFieldType="percentage"
               [disabled]=" personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()">
        <span class="input-icon-span-right">%</span>
      </div>
      <validation-message [control]="entireRatePerOption"></validation-message>
    </div>
  </div>

</div>

<div class="row">
  <div class="col-sm-12">
    <h3>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.TaxInformation.Fields.NumberDependentsTitle' | translate}}</h3>
  </div>
</div>

<div class="row">

  <!--Sem incapacidade permanente-->
  <!--Activo: Sim, se Benefício Requerido = SO ou SM e Tipologia de pessoa = Singular e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="WithoutDisability"
             [class.disabled]="personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!( personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.TaxInformation.Fields.WithoutPermanentDisability' | translate}}
        <span class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberFiscalInfo.NumberOfDependents.WithoutDisability' | translate}}"></span>
      </label>
      <div class="position-relative">
        <input class="form-control input-right"
               type="text"
               numeric="2"
               placeholder="{{'Placeholders.CardSubscriberFiscalInfo.NumberOfDependents.WithoutDisability' | translate}}"
               [(ngModel)]="cardData.dependentsWithoutDisability"
               #dependentsWithoutDisability="ngModel"
               name="dependentsWithoutDisability"
               maxValue="10"
               [disabled]="personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()"
               [required]="!( personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido())">
        <validation-message [control]="dependentsWithoutDisability"></validation-message>
      </div>
    </div>
  </div>

  <!--Com incapacidade permanente-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="WithDisability" [class.disabled]="  personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!(  personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.TaxInformation.Fields.WithPermanentDisability' | translate}}
        <span class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberFiscalInfo.NumberOfDependents.WithDisability' | translate}}"></span>
      </label>
      <div class="position-relative">
        <input class="form-control input-right"
               type="text"
               numeric="1"
               maxlength="2"
               placeholder="{{'Placeholders.CardSubscriberFiscalInfo.NumberOfDependents.WithDisability' | translate}}"
               [(ngModel)]="cardData.dependentsWithDisability"
               #dependentsWithDisability="ngModel"
               name="dependentsWithDisability"
               maxValue="5"
               [disabled]=" personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido()"
               [required]="!( personTypologyCode?.toString() != personTypeValues.Singular || isNotStateRLDiferido())">
        <validation-message [control]="dependentsWithDisability"></validation-message>
      </div>
    </div>
  </div>
</div>
